import { useEffect } from 'react';
import { getReCaptchaKey } from '../utils/utils';

const useReCaptcha = (props) => {
  const { onSubmit } = props;
  const siteKey = getReCaptchaKey();

  const getToken = () => {
    const grecaptcha = window.grecaptcha.enterprise;
    grecaptcha.ready(() => {
      grecaptcha.execute(`${siteKey}`, { action: 'check_balance' }).then((token) => {
        onSubmit(token);
      });
    });
  };

  useEffect(() => {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${siteKey}`;
    document.body.appendChild(script);
  }, []);

  return { getToken };
};

export default useReCaptcha;
